module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="pages">\r\n  <a href="#" title="首页" class="disabled"><i class="iconfont icon-first"></i></a>\r\n  <a href="#" title="上一页" class="disabled"><i class="iconfont icon-left-arrow"></i></a>\r\n  <a href="#" class="active">1</a>\r\n  <a href="#">2</a>\r\n  <a href="#">3</a>\r\n  <a href="#">4</a>\r\n  <a href="#">5</a>\r\n  <a href="#" title="下一页"><i class="iconfont icon-right-arrow"></i></a>\r\n  <a href="#" title="末页"><i class="iconfont icon-endpage"></i></a>\r\n</div>';

}
return __p
}